<p-dialog header="Header"
          [(visible)]="visible"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          styleClass="w-[50vw] max-w-full lg:w-[33.33vw]">
  <ng-template #header>
    <div class="flex-flex-col w-full gap-1">
      <label class="text-left font-bold">{{ 'alertCodes.' + alert.description | translate }}</label>
      <p-divider />
    </div>
  </ng-template>

  <div class="flex flex-col gap-3">
    <div class="grid w-full grid-cols-3 items-center gap-2 px-4 py-2">
      <label class="text-left text-sm font-semibold">{{ 'date' | translate }}</label>
      <label class="col-span-2">{{ alert.timeStamp | date:'medium' }}</label>

      <label class="text-left text-sm font-semibold">{{ 'value' | translate }}</label>
      @if(isTrend) {
      <app-trend-indicator class="justify-self-start" [value]="alert.value" [type]="mode" />
      } @else {
      <app-threshold-indicator class="justify-self-start" [value]="alert.value" [type]="mode" />
      }
      <label>{{ uom }}</label>
    </div>

    <p-divider />

    <div class="grid w-full grid-cols-3 items-center gap-2 px-4 py-2">
      <label class="text-left text-sm font-semibold">{{ 'verifiedBy' | translate }}</label>
      <label class="col-span-2">{{ alert.checker }}</label>

      <label class="text-left text-sm font-semibold">{{ 'verifiedAt' | translate }}</label>
      <label class="col-span-2">{{ alert.checkedAt === 0 ? '---' : ( alert.checkedAt | date:'medium' ) }}</label>
    </div>
  </div>

  <ng-template #footer>
    <p-button [label]="'primeng.cancel' | translate"
              [text]="true"
              severity="secondary"
              variant="outlined"
              (click)="onClose()" />
    <p-button [label]="'verified' | translate"
              [disabled]="alert.isChecked"
              (click)="onSave()" />
  </ng-template>
</p-dialog>
